import {Environment, Network, RecordSource, Store, QueryResponseCache} from 'relay-runtime';
import {createConsumer} from '@rails/actioncable';
import createRelaySubscriptionHandler from 'graphql-ruby-client/subscriptions/createRelaySubscriptionHandler';

import csrf from './utils/csrf';
import {apiV1GraphQLPath} from './api/routes';

let inFlightRequests = 0;
let doneTimer = null; // debounce setting data-fetching="done" to avoid flickers

function updateFetchingStatus() {
  if (inFlightRequests > 0) {
    // If there are requests processing, don't allow data-fetching="done" to be set
    if (doneTimer) {
      clearTimeout(doneTimer);
      doneTimer = null;
    }

    document.body?.setAttribute('data-fetching', 'true');
  } else {
    // There are no requests processing, so allow data-fetching="done" to be set eventually
    doneTimer = setTimeout(() => {
      document.body?.setAttribute('data-fetching', 'done');
    }, 100);
  }
}

// 25 cache entries, 300 seconds until cache is invalid.
export const cache = new QueryResponseCache({size: 25, ttl: 300000});
export const fetchQuery = async (operation, variables, cacheConfig) => {
  const queryId = operation.name;
  const cachedData = cache.get(queryId, variables);
  const forceLoad = cacheConfig && cacheConfig.force;

  if (!forceLoad && cachedData) {
    // Return promise to keep returns consistent
    // eslint-disable-next-line no-promise-executor-return
    return new Promise(resolve => resolve(cachedData));
  }

  inFlightRequests += 1;
  updateFetchingStatus();

  try {
    const query = operation.text.replace(/\s+/g, ' ');
    const result = await fetch(apiV1GraphQLPath(), {
      credentials: process.env.NODE_ENV === 'development' ? 'include' : 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...csrf.headers,
      },
      body: JSON.stringify({
        query,
        variables,
        operationName: queryId,
      }),
    });

    const json = await result.json();
    cache.set(queryId, variables, json);
    return json;
  } finally {
    // Ensure the number of active requests is as up to date as possible
    inFlightRequests = Math.max(0, inFlightRequests - 1);
    updateFetchingStatus();
  }
};

const subscriptionHandler = createRelaySubscriptionHandler({
  cable: createConsumer(),
  channelName: 'GraphQLChannel',
});

const environment = new Environment({
  network: Network.create(fetchQuery, subscriptionHandler),
  store: new Store(new RecordSource()),
});

export default environment;
